var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('tr', {
    style: `opacity: ${_vm.isScored ? 1 : 0.5}`
  }, [_c('th', {
    attrs: {
      "scope": "row"
    }
  }, [_vm._v(" " + _vm._s(_vm.domainIndicator.Name) + " "), _vm.showDisclaimer() ? _c('p', {
    staticStyle: {
      "font-size": "13px",
      "font-weight": "normal"
    }
  }, [_vm._v(" " + _vm._s(_vm.disclaimer) + " ")]) : _vm._e()]), _c('td', {
    key: _vm.$store.getters.cycle.IPPCycleYear,
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fas fa-info-circle text-muted",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "data-html": "true",
      "data-title": _vm.detail,
      "original-title": _vm.detail
    }
  })]), _vm.isScored ? _c('td', {
    staticClass: "text-nowrap"
  }, [_vm._v("n=" + _vm._s(_vm._f("numFormat")(_vm.factPossibleCount)))]) : _vm._e(), !_vm.isScored ? _c('td', {
    staticClass: "text-nowrap"
  }, [_vm._v(" " + _vm._s(_vm.ineligibilityReason && _vm.ineligibilityReason.NSizeDisplay ? _vm.ineligibilityReason.NSizeDisplay : "--") + " ")]) : _vm._e(), _c('td', {
    staticClass: "px-4",
    staticStyle: {
      "min-width": "12rem",
      "width": "16rem"
    }
  }, [_c('div', {
    staticClass: "performance position-relative mb-1",
    style: `opacity: ${_vm.fact.IneligibilityReasonId || _vm.fact.IndicatorPointsEarned === null ? 0.5 : 1}`
  }, [_c('small', {
    directives: [{
      name: "centered-offset",
      rawName: "v-centered-offset",
      value: 'left',
      expression: "'left'"
    }],
    staticClass: "position-relative font-weight-bold",
    style: `left: ${_vm.performance}%; transition: left 350ms ease-in-out;`
  }, [_vm._v(_vm._s(_vm.fact.IneligibilityReasonId || _vm.fact.IndicatorPointsEarned === null ? "N/A" : `${_vm.performance}%`))]), _c('div', {
    directives: [{
      name: "centered-offset",
      rawName: "v-centered-offset",
      value: 'left',
      expression: "'left'"
    }],
    staticClass: "position-absolute",
    staticStyle: {
      "border-left": "1px solid #000",
      "top": "100%",
      "height": "0.85rem"
    },
    style: `left: ${_vm.performance}%; transition: left 350ms ease-in-out;`
  }, [_c('i', {
    directives: [{
      name: "centered-offset",
      rawName: "v-centered-offset",
      value: 'top left',
      expression: "'top left'"
    }],
    staticClass: "fas fa-circle position-absolute",
    staticStyle: {
      "top": "100%",
      "font-size": "50%",
      "width": "0.5rem"
    }
  })])]), _c('div', {
    staticClass: "performance-bar"
  }, [_c('div', {
    staticClass: "bg-dark performance-bar-background"
  }), _c('div', {
    staticClass: "bg-dark performance-designation",
    style: `left: ${_vm.domainIndicator.MinimumStandard * 100}%; right: ${100 - _vm.domainIndicator.StateTarget * 100}%`,
    attrs: {
      "data-toggle": "tooltip",
      "data-html": "true",
      "data-title": `<div class='d-flex'><span class='font-weight-bold flex-fill pr-1'>Min Standard:</span> ${_vm.domainIndicator.MinimumStandard * 100}%
                      </div><div class='d-flex'><span class='font-weight-bold flex-fill pr-1'>State Target:</span> ${_vm.domainIndicator.StateTarget * 100}%</div>`,
      "original-title": `<div class='d-flex'><span class='font-weight-bold flex-fill pr-1'>Min Standard:</span> ${_vm.domainIndicator.MinimumStandard * 100}%
                      </div><div class='d-flex'><span class='font-weight-bold flex-fill pr-1'>State Target:</span> ${_vm.domainIndicator.StateTarget * 100}%</div>`
    }
  })]), _c('div', {
    staticClass: "row no-gutters text-muted"
  }, [_c('div', {
    staticClass: "col-6 row no-gutters"
  }, [_c('div', {
    staticClass: "col-6 position-relative"
  }, [_c('small', {
    directives: [{
      name: "centered-offset",
      rawName: "v-centered-offset",
      value: 'left',
      expression: "'left'"
    }],
    staticClass: "d-inline-block position-relative"
  }, [_vm._v("0%")])]), _c('div', {
    staticClass: "col-6 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "d-flex flex-fill align-items-center position-relative"
  }, [_c('small', {
    directives: [{
      name: "centered-offset",
      rawName: "v-centered-offset",
      value: 'left',
      expression: "'left'"
    }],
    staticClass: "d-inline-block position-relative"
  }, [_vm._v("25%")]), _c('div', {
    staticClass: "flex-fill"
  }), _c('small', {
    directives: [{
      name: "centered-offset",
      rawName: "v-centered-offset",
      value: 'right',
      expression: "'right'"
    }],
    staticClass: "d-inline-block position-relative"
  }, [_vm._v("50%")])])])]), _c('div', {
    staticClass: "col-6 row no-gutters"
  }, [_c('div', {
    staticClass: "col-6 text-right position-relative"
  }, [_c('small', {
    directives: [{
      name: "centered-offset",
      rawName: "v-centered-offset",
      value: 'right',
      expression: "'right'"
    }],
    staticClass: "d-inline-block position-relative"
  }, [_vm._v("75%")])]), _c('div', {
    staticClass: "col-6 text-right position-relative"
  }, [_c('small', {
    directives: [{
      name: "centered-offset",
      rawName: "v-centered-offset",
      value: 'right',
      expression: "'right'"
    }],
    staticClass: "d-inline-block position-relative"
  }, [_vm._v("100%")])])])])]), _vm.isScored ? _c('td', {
    staticClass: "text-nowrap text-right"
  }, [_vm._v(" " + _vm._s(_vm._f("numFormat")(_vm.fact.IndicatorPointsEarned ? _vm.fact.IndicatorPointsEarned : 0, "0.00")) + " out of " + _vm._s(_vm.domainIndicator.PointsPossible) + " ")]) : _vm._e(), !_vm.isScored ? _c('td', {
    staticClass: "text-nowrap text-right"
  }, [_vm._v("No Points")]) : _vm._e(), _c('td'), !_vm.isScored ? _c('td', {
    staticClass: "text-nowrap text-center",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.ineligibilityReason ? _vm.ineligibilityReason.Description : "") + " ")]) : _vm._e(), _vm.isScored ? _c('td') : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };